<template>
  <span :class="`mc-avatar ${computedVariant} ${computedSize}`">
    <img class="mc-avatar--image" v-if="image" :src="image" :title="text" :alt="text" />
    <span class="mc-avatar--text" v-if="text">{{ text }}</span>
    <McBadge
      v-if="badgeText"
      :text="badgeText"
      :type="badgeType"
      :variant="badgeVariant"
      :size="size"
      :class="`${computedBadgePosition}`"
    ></McBadge>
  </span>
</template>
    
    <script>
import McBadge from '@/components/McBadge'
export default {
  components: {
    McBadge,
  },

  props: {
    text: {
      type: String,
      required: true,
    },
    image: {
      type: String,
    },
    variant: {
      type: String,
      default: 'outlinePrimary',
    },
    size: {
      type: String,
      default: 'medium',
    },

    badgeText: {
      type: String,
    },

    badgeType: {
      type: String,
      default: 'pill',
    },

    badgeVariant: {
      type: String,
      default: 'canceled',
    },

    badgePosition: {
      type: String,
      default: 'top',
    },
  },
  computed: {
    computedVariant() {
      const defaultVariant = 'mc-outline-primary'
      const variantMapping = {
        outlinePrimary: 'mc-outline-primary',
        outlineSecondary: 'mc-outline-secondary',
        outlineSuccess: 'mc-outline-success',
        outlineDanger: 'mc-outline-danger',
        outlineWarning: 'mc-outline-warning',
        outlineInfo: 'mc-outline-info',
        outlinePink: 'mc-outline-pink',
        outlinePurple: 'mc-outline-purple',
      }

      return variantMapping[this.variant] || defaultVariant
    },

    computedSize() {
      const defaultSize = 'mc-avatar--medium'
      const sizeMapping = {
        medium: 'mc-avatar--medium',
        large: 'mc-avatar--large',
        small: 'mc-avatar--small',
      }

      return sizeMapping[this.size] || defaultSize
    },

    computedBadgePosition() {
      const defaultBadgePosition = 'top'
      const badgePositionMapping = {
        top: 'top',
        bottom: 'bottom',
      }

      return badgePositionMapping[this.badgePosition] || defaultBadgePosition
    },
  },
}
</script>
    